// Recovered compiled webpack factory 28890. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function () {
        return l;
      },
    }));
  let n = r(28140),
    a = r(95155);
  r(12115);
  let o = n._(r(77759)),
    i = r(88785),
    s = (0, r(93913).isBot)(window.navigator.userAgent);
  function l(e) {
    let { children: t, errorComponent: r, errorStyles: n, errorScripts: l } = e;
    return s
      ? (0, a.jsx)(o.default, { children: t })
      : (0, a.jsx)(i.ErrorBoundary, {
          errorComponent: r,
          errorStyles: n,
          errorScripts: l,
          children: t,
        });
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
